import React from 'react';
import LegalPageLayout from './LegalPageLayout';
import { Phone, Building2 } from 'lucide-react';

// Official WhatsApp Logo Component
const WhatsAppIcon = ({ className = "w-5 h-5" }) => {
  return (
    <svg 
      viewBox="0 0 24 24" 
      className={className} 
      fill="currentColor" 
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.438 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413z"/>
    </svg>
  );
};

const ContactUs = () => {
  const WHATSAPP_NUMBER = "916381326346";
  const PHONE_DISPLAY = "+91 63813 26346";
  const WHATSAPP_LINK = `https://wa.me/${WHATSAPP_NUMBER}?text=வணக்கம்! அருள்வாக்கு நிலையம் மூலம் ஆலோசனை பெற விரும்புகிறேன்.`;

  return (
    <LegalPageLayout title="Contact Us">
      <div className="space-y-12 font-tamil-body">
        <section className="text-center">
          <div className="inline-flex items-center gap-3 mb-6">
            <h2 className="text-3xl font-bold text-amber-400">தொடர்பு கொள்ள</h2>
          </div>
          <p className="text-amber-100/70 text-lg max-w-xl mx-auto">
            உங்கள் கவலைகளுக்கு அம்மனின் வாக்கு மூலம் நேரடித் தீர்வு பெற எங்களைத் தொடர்பு கொள்ளுங்கள்.
          </p>
        </section>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
          {/* Business Info */}
          <div className="bg-white/5 p-8 rounded-3xl border border-white/10 flex flex-col items-center text-center">
            <div className="w-16 h-16 bg-amber-500/10 rounded-full flex items-center justify-center mb-6 text-amber-400 border border-amber-500/20">
              <Building2 className="w-8 h-8" />
            </div>
            <p className="text-amber-200 text-xl font-bold mb-1">அருள்வாக்கு நிலையம்</p>
            <p className="text-amber-200/60">(Arulvaaku Nilayam)</p>
          </div>

          {/* Contact Methods */}
          <div className="bg-white/5 p-8 rounded-3xl border border-white/10 flex flex-col items-center text-center">
            <div className="w-16 h-16 bg-green-500/10 rounded-full flex items-center justify-center mb-6 text-green-400 border border-green-500/20">
              <Phone className="w-8 h-8" />
            </div>
            <h3 className="text-xl font-bold text-white mb-2">WhatsApp / Phone</h3>
            <a 
              href={`tel:${WHATSAPP_NUMBER}`}
              className="text-amber-200 text-lg hover:text-amber-400 transition-colors"
            >
              {PHONE_DISPLAY}
            </a>
          </div>
        </div>

        {/* Action Button */}
        <div className="flex justify-center pt-8">
          <a
            href={WHATSAPP_LINK}
            target="_blank"
            rel="noopener noreferrer"
            className="flex items-center gap-3 bg-[#25D366] hover:bg-[#128C7E] text-white font-bold px-10 py-5 rounded-full text-xl shadow-2xl shadow-green-500/20 transition-all transform hover:scale-105 active:scale-95"
          >
            <WhatsAppIcon className="w-7 h-7" />
            அம்மனின் அருள்வாக்கு பெற
          </a>
        </div>
      </div>
    </LegalPageLayout>
  );
};

export default ContactUs;
